import { useReducer } from 'react';

import { reduceRelayPaginationAction, RelayPaginationState } from '../../pagination';
import { ProviderAppActionPayload } from './action';
import { initialState, ProviderAppState } from './state';


function reducer (state: ProviderAppState, action: ProviderAppActionPayload): ProviderAppState {
    switch (action.type) {
        case 'MODAL_ACTION':
            const { type, referral = null, ...modal } = action;
            return {
                ...state,
                referral,
                modal: {
                    ...state.modal,
                    ...modal,
                }
            };
        case 'RELAY_PAGINATION_ACTION':
            return {
                ...state,
                pagination: reduceRelayPaginationAction(state.pagination, action)
            };
        case 'SET_PAGE_SIZE':
            return {
                ...state,
                pagination: state.pagination.newPageSize(action.pageSize),
            };
        case 'REFERRAL_FILTER_ACTION':
            return {
                ...state,
                filter: action.filter,
                pagination: new RelayPaginationState('0', state.pagination.size),
            }
        case 'TOGGLE_OFFER_CONVERSATION_ONLY':
            return {
                ...state,
                offerConversationOnly: !state.offerConversationOnly,
                pagination: new RelayPaginationState('0', state.pagination.size),
            }
        default:
            return state;
    }
}

export const useProviderAppReducer = (initialValues: Partial<ProviderAppState> = {}) => useReducer(reducer, {
    ...initialState,
    ...initialValues
});
